import { useState } from 'react'
import { isEmpty } from '@neo/ramda-extra'
import { loanApplicationService } from '@vega/lending/src/apiService'
import { useDebouncedCallback } from 'use-debounce'

const useSearchApplicant = (delay = 1000) => {
  const [isLoading, setIsLoading] = useState(false)
  const [results, setResults] = useState([])

  const applicantSearch = useDebouncedCallback(async (query) => {
    if (isEmpty(query)) {
      setResults([])
      return
    }

    setIsLoading(true)

    try {
      const applicants = await loanApplicationService.searchApplicants(query)
      setResults(applicants)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }, delay)

  const resetResults = () => setResults([])
  return {
    isLoading,
    results,
    applicantSearch,
    resetResults,
  }
}

export { useSearchApplicant }
